/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import IObservable from '../../Observable/IObservable';
import Observable from '../../Observable/Observable';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import ReferencedComponent from '../ComponentReference/ReferencedComponent';
import ObservableNodeComponent from '../Observable/ObservableNodeComponent';

/**
 * Data serialized class for storing a refernece to a node.
 */
const {ccclass, property} = cc._decorator;

@ccclass("NodeReferenceData")
export default class NodeReferenceData
{
    /** Node property. */
    @property({ type: cc.Node })
    public Node: cc.Node = null;

    /** Node reference property. */
    @property({ type: ObservableNodeComponent })
    public ObservableNode: IObservable<cc.Node> = null;

    @property(InjectableComponent)
    protected reference: InjectableComponent<ReferencedComponent> = new InjectableComponent();

    /** Gets the node value of the observable or local property. */
    public get Value(): cc.Node
    {
        if (!this.ObservableNode) { this.ObservableNode = new Observable<cc.Node>(); }
        if (!this.ObservableNode.Value)
        {
            if (this.Node) { this.ObservableNode.Value = this.Node; }
            else if (this.reference.InstanceID)
            {
                let reference: ReferencedComponent = this.reference.SetContext(ReferencedComponent).Value;

                if (reference)
                {
                    this.ObservableNode.Value = reference.node;
                }
            }
        }

        return this.ObservableNode.Value;
    }

    /** Public setter for setting node reference. */
    public set Value(value: cc.Node)
    {
        if (this.ObservableNode)
        {
            this.ObservableNode.Value = value;
            return;
        }

        this.Node = value;
    }

    public HasValue(): boolean
    {
        return this.Value !== null && this.Value !== undefined;
    }
}
